(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bundle-items"] && !Shopify.designMode) return;
  try {
    // Module-level cache persists across DOM lifecycle (keyed by product GID)
const _bundleCache = new Map();

class BundleItemsBlock extends HTMLElement {
  /** @type {AbortController|null} */
  #abortController = null;

  connectedCallback() {
    if (this.dataset.hasManual === 'true') return;

    const productGid = this.dataset.productGid;
    const shopDomain = this.dataset.shopDomain;

    if (!productGid || !shopDomain) return;

    this.#abortController = new AbortController();
    this.#listenForVariantChanges();

    const cached = _bundleCache.get(productGid);
    if (cached) {
      this.#renderForCurrentVariant(cached);
    } else {
      this.#fetchBundleComponents(shopDomain, productGid);
    }
  }

  disconnectedCallback() {
    this.#abortController?.abort();
    this.#abortController = null;
  }

  #listenForVariantChanges() {
    const section = this.closest('.shopify-section, dialog, product-card');
    const target = section || document;

    target.addEventListener('variant:update', (event) => {
      const variants = _bundleCache.get(this.dataset.productGid);
      if (!variants) return;

      const selectedId = event.detail?.resource?.id;
      if (!selectedId) return;

      const variantGid = `gid://shopify/ProductVariant/${selectedId}`;
      const matched = variants.find(v => v.id === variantGid);

      if (matched?.requiresComponents && matched.components?.nodes?.length) {
        this.#render(this.#aggregateComponents(matched.components.nodes));
      } else {
        this.#renderDefaultBundle(variants);
      }
    }, { signal: this.#abortController.signal });
  }

  #renderForCurrentVariant(variants) {
    const urlVariantId = new URL(window.location.href).searchParams.get('variant');
    if (urlVariantId) {
      const variantGid = `gid://shopify/ProductVariant/${urlVariantId}`;
      const matched = variants.find(v => v.id === variantGid);
      if (matched?.requiresComponents && matched.components?.nodes?.length) {
        this.#render(this.#aggregateComponents(matched.components.nodes));
        return;
      }
    }
    this.#renderDefaultBundle(variants);
  }

  #renderDefaultBundle(variants) {
    const fallback = variants.find(v => v.requiresComponents && v.components?.nodes?.length);
    if (fallback) {
      this.#render(this.#aggregateComponents(fallback.components.nodes));
    } else {
      this.#hide();
    }
  }

  #aggregateComponents(components) {
    const seen = new Map();
    for (const comp of components) {
      const handle = comp.productVariant?.product?.handle;
      if (!handle) continue;

      const variantImage = comp.productVariant.image;

      if (seen.has(handle)) {
        seen.get(handle).quantity += comp.quantity;
      } else {
        seen.set(handle, {
          title: comp.productVariant.product.title,
          handle,
          imageUrl: variantImage?.url ?? '',
          imageAlt: variantImage?.altText ?? '',
          quantity: comp.quantity,
        });
      }
    }
    return [...seen.values()];
  }

  async #fetchBundleComponents(shop, productGid) {
    const query = `
      query BundleComponents($id: ID!) {
        product(id: $id) {
          variants(first: 10) {
            nodes {
              id
              requiresComponents
              components(first: 25) {
                nodes {
                  quantity
                  productVariant {
                    id
                    title
                    image {
                      url
                      altText
                      width
                      height
                    }
                    product {
                      handle
                      title
                    }
                  }
                }
              }
            }
          }
        }
      }
    `;

    try {
      const response = await fetch(`https://${shop}/api/2025-04/graphql.json`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ query, variables: { id: productGid } }),
      });

      if (!response.ok) return;

      const json = await response.json();
      const variants = json?.data?.product?.variants?.nodes;
      if (!variants?.length) return;

      _bundleCache.set(productGid, variants);
      this.#renderForCurrentVariant(variants);
    } catch {
      // Silently fail — block stays hidden if not a bundle
    }
  }

  #render(items) {
    if (!items.length) {
      this.#hide();
      return;
    }

    let list = this.querySelector('[ref="list"]');
    if (!list) {
      list = document.createElement('ul');
      list.className = 'bundle-items__list';
      list.setAttribute('ref', 'list');
      const headingText = this.querySelector('[ref="heading"]')?.textContent?.trim();
      list.setAttribute('aria-label', headingText || 'Bundle items');
      this.appendChild(list);
    }

    const showImage = this.dataset.showImage === 'true';
    const showLink = this.dataset.showLink === 'true';
    const showQty = this.dataset.showQuantity === 'true';
    const imgSize = parseInt(this.dataset.imageSize, 10) || 60;

    const html = items.map(item => {
      const imageHtml = showImage && item.imageUrl
        ? `<div class="bundle-items__image-wrapper">
            <img
              src="${item.imageUrl}&width=${imgSize * 2}&height=${imgSize * 2}&crop=center"
              alt="${this.#escapeHtml(item.imageAlt || item.title)}"
              class="bundle-items__image"
              loading="lazy"
              width="${imgSize}"
              height="${imgSize}"
            >
          </div>`
        : '';

      const titleHtml = showLink
        ? `<span class="bundle-items__title-link">${this.#escapeHtml(item.title)}</span>`
        : `<span class="bundle-items__title">${this.#escapeHtml(item.title)}</span>`;

      const qtyHtml = showQty
        ? `<span class="bundle-items__qty">Qty: ${item.quantity}</span>`
        : '';

      const itemContentHtml = `
        ${imageHtml}
        <div class="bundle-items__details">
          ${titleHtml}
          ${qtyHtml}
        </div>
      `;

      return `<li class="bundle-items__item">${
        showLink
          ? `<a href="/products/${item.handle}" class="bundle-items__item-link">${itemContentHtml}</a>`
          : itemContentHtml
      }</li>`;
    }).join('');

    list.innerHTML = html;
    list.hidden = false;
    this.removeAttribute('hidden');
  }

  #hide() {
    this.querySelector('[ref="list"]')?.remove();
    this.setAttribute('hidden', '');
  }

  #escapeHtml(str) {
    const div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }
}

customElements.define('bundle-items-block', BundleItemsBlock);
  } catch(e) { console.error(e); }
})();

})();
